import { JourneyFilters } from './useJourneyFilters';
import { FragmentType, getFragmentData, graphql } from '../gql';

const journeyFilters_phases = graphql(`
	fragment journeyFilters_phases on Phase {
		id
		touchpoints(filter: { type: { eq: activity } }) {
			id
			activity {
				satisfaction
				duration {
					end
					start
					type
				}
				tags {
					id
				}
				personas {
					id
				}
				owner {
					id
				}
			}
		}
	}
`);

type ApplyJourneyFiltersArgs<T> = {
	phases: readonly (FragmentType<typeof journeyFilters_phases> & { touchpoints: { id: string }[] } & T)[];
	filters: JourneyFilters;
};

export const applyJourneyFilters = <T>({ phases, filters }: ApplyJourneyFiltersArgs<T>): T[] => {
	const newPhases = phases.map((phase) => {
		const phaseFragment = getFragmentData(journeyFilters_phases, phase);
		const filteredTouchpoints = phaseFragment.touchpoints
			.filter((item) => {
				if (filters.duration === 'one_time') {
					return item.activity?.duration?.type === 'one_time';
				}

				if (filters.duration === 'occurence') {
					return item.activity?.duration?.type === 'occurence';
				}

				if (filters.duration === 'continuous') {
					return item.activity?.duration?.type === 'continuous';
				}

				return true;
			})
			.filter((item) => {
				const startDate = filters.date ? new Date(filters.date.start) : null;
				const endDate = filters.date ? new Date(filters.date.end) : null;

				if (!startDate || !endDate) {
					return true;
				}

				const activityEnd = item.activity?.duration?.end ? new Date(item.activity.duration.end) : new Date(0);
				const activityStart = item.activity?.duration?.start ? new Date(item.activity.duration.start) : new Date();

				return startDate <= activityEnd && endDate >= activityStart;
			})
			.filter((tp) => {
				const activity = tp.activity!;

				if (filters.tags && filters.tags.length > 0) {
					if (!filters.tags.some((tag) => activity.tags.some((activityTag) => activityTag.id === tag))) {
						return false;
					}
				}

				return true;
			})
			.filter((item) => {
				if (filters.warningsOnly === 'true') {
					// TODO: TS error there is no warnings in activity, but there is!!  ??
					// @ts-ignore
					return item.activity?.warnings?.length > 0;
				}
				return true;
			})
			.filter((item) => {
				if (filters.satisfactions && filters.satisfactions.length > 0) {
					return item.activity?.satisfaction != null && filters.satisfactions.includes(item.activity.satisfaction.toString());
				}
				return true;
			})
			.filter((item) => {
				if (filters.personas && filters.personas.length > 0) {
					if (!filters.personas.some((persona) => item.activity?.personas.some((activityPersona) => activityPersona.id === persona))) {
						return false;
					}
				}
				return true;
			})
			.filter((item) => {
				if (filters.owners && filters.owners.length > 0) {
					if (!filters.owners.some((owner) => item.activity?.owner?.id === owner)) {
						return false;
					}
				}
				return true;
			});

		const filteredTouchpointIds = filteredTouchpoints.map((tp) => tp.id);

		return {
			...phase,
			// NOTE: this includes not only ids but data from other fragments which this function isn't aware of
			touchpoints: phase.touchpoints.filter((tp) => filteredTouchpointIds.includes(tp.id)),
		};
	});

	return newPhases;
};
